import Cookies from "js-cookie";
const TokenKey = "hb_token";
const TOKEN_REFRESH_KEY = "hb_token_refresh";
export function getToken() {
  return Cookies.get(`${TokenKey}`);
}
export function setRefreshToken(token) {
  return Cookies.set(TOKEN_REFRESH_KEY, token);
}
export function setToken(token) {
  return Cookies.set(`${TokenKey}`, token);
}
export function removeToken() {
  return Cookies.remove(`${TokenKey}`) && Cookies.remove(TOKEN_REFRESH_KEY);
}